import { getInvitationByUuidQuery } from '@/api/invitations/invitationQueries';
import { Spinner } from '@/components/common/Spinner';
import { routes } from '@/routes/routes';
import { useQuery } from '@tanstack/react-query';
import { useNavigate, useParams } from '@tanstack/react-router';
import { useEffect } from 'react';

export const InvitationPage = () => {
  const { invitationId } = useParams({
    from: '/invitation/$invitationId',
  });
  const navigate = useNavigate();

  const {
    data: invitation,
    isLoading,
    isError,
  } = useQuery(getInvitationByUuidQuery(invitationId));

  useEffect(() => {
    if (isError) {
      navigate({ to: routes.home, replace: true });
    }
  }, [isError, navigate]);

  useEffect(() => {
    if (!invitation?.data) return;
    const inv = invitation.data;
    const isDoctor = inv.role === 'Doctor';

    if (isDoctor) {
      navigate({
        to: routes.auth.resetPassword,
        search: { invitation: inv.uuid, email: inv.email },
        replace: true,
      });
    } else {
      navigate({
        to: routes.auth.register,
        search: {
          name: inv.name,
          surname: inv.surname,
          email: inv.email,
          invitation: inv.uuid,
        },
        replace: true,
      });
    }
  }, [invitation, navigate]);

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Spinner className="size-8" />
      </div>
    );
  }

  return null;
};
